import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getUserOrdersDetail } from "../services/orderService";
import "../styles/order.css";
import moment from "moment";
import "moment/locale/fa";
import {
  ChevronRight,
  ReceiptText,
  Receipt,
  MapPinCheckInside,
  Truck,
} from "lucide-react";

import OrderDetailSkeleton from "./Dashboard/Skeleton/Orders/OrderDetailSkeleton/OrderDetailSkeleton";


import InvoiceDownloadButton from "../pdf/InvoiceDownloadButton";

export default function OrderDetail() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");




  useEffect(() => {

    const loadOrdersDetail = async () => {

      try {

        setLoading(true);

        const response = await getUserOrdersDetail(id);
        console.log("Response",response);
        setOrder(response);

      } catch (error) {

        console.error("Failed to load Orders:", error);

        setError("Error Orders not found.");

      } finally {

        setLoading(false);
      }
    };

    loadOrdersDetail();

  }, []);



if (loading) {
  return   <OrderDetailSkeleton />;
 
}


  if (error || !order) {
    return (
      <div className="content-detail">
        <h2>Order not found</h2>
      </div>
    );
  }

  return (
    <div className="p-4">
      {/* Back Button */}

      {/* <OrderDetailSkeleton /> */}

      <div className="backOrder" onClick={() => navigate(-1)}>
        <ChevronRight size={24} />
        <h3> جزئیات سفارش</h3>
      </div>


      <div className="orderDetails">
        <h2>
          <ReceiptText strokeWidth={1} size={24} />
          مشخصات سفارش
        </h2>
        <div className="orderAmount brl">
          <div className="trackingCode">
            <p>کدپیگیری سفارش:</p>
            <p className="pr">CDCP-{order.data.id}</p>
          </div>
          <div className="orderRegDate">
            <p>تاریخ ثبت سفارش:</p>
            <p className="pr">{order.data.order_date}</p>
          </div>

          <div className="amountPaid">
            <div className="amountReg">
              <div className="amount brl">
                <p>مبلغ کل:</p>
                <p className="pr">
                  {" "}
                  {Number(order.data.amount).toLocaleString()} تومان
                </p>
              </div>

              <div className="shipping">
                <p> هزینه ارسال:</p>
                <p className="pr">
                  {" "}
                  {Number(order.data.shipping).toLocaleString()} تومان
                </p>
              </div>
            </div>
            <div className="amountTotal">
              <div className="amountTotalPaid">
                <p>مبلغ پرداخت شده:</p>
                <p className="pr">
                  {Number(
                    order.data.amount - order.data.discount - order.data.wallet,
                  ).toLocaleString()}
                  تومان
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="transactionHistory">
        <h2>
          <Receipt strokeWidth={1} size={24} />
          تاریخچه تراکنش ها
        </h2>
        <div className="transaction">
          <table className="transaction-table">
            <thead>
              <tr>
                <th>تاریخ</th>
                <th>وضعیت</th>
                <th>مبلغ</th>
                <th>روش پرداخت</th>
                <th>شماره پیگیری</th>
                <th>توضیحات</th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td>
                  {new Date(order.payment.created_at.date).toLocaleString(
                    "fa-IR",
                  )}
                </td>

                <td>{order.payment.status}</td>
                <td>{order.payment.amount.toLocaleString()} تومان</td>

                <td>
                  پرداخت {order.payment.method}
                  {order.payment.gateway && (
                    <span className="gatewayTitle">
                      (درگاه {order.payment.gateway})
                    </span>
                  )}
                </td>

                <td>{order.payment.system_trace_no}</td>
                <td>پرداخت {order.payment.status}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div className="orderDelivery ">
        <h2>
          <MapPinCheckInside strokeWidth={1} size={24} />
          مشخصات گیرنده و مقصد
        </h2>
        <div className="orderDelivery-user">
          <div className="receiver">
            <div className="receiverOrder">
              <div className="mobile brl">
                <p>شماره تماس :</p>
                <p className="pr"> {order.userAddress.mobile}</p>
              </div>

              <div className="receiverUser">
                <p className="pr"> تحویل گیرنده :</p>
                <p className="pr">
                  {order.userAddress.fname}&nbsp;
                  {order.userAddress.lname}
                </p>
              </div>
            </div>
            <div className="location">
              <div className="locationTo">
                <p className="w-10">ارسال به :</p>
                <p className="w-100 pr">
                  {order.userAddress.province} - {order.userAddress.city}-{" "}
                  {order.userAddress.address}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="orderProducts">
        <div className="orderFactorGet">
          <p>مرسوله 1 از 1</p>
          <InvoiceDownloadButton order={order} />
        </div>


        <div className="orderSend">
          <p>
            <Truck strokeWidth={1} size={24} />
            {order.deliveryType.sendType} کافه دارو{" "}
          </p>
          <p className="qtyOrder">{order.products.length} محصول</p>
        </div>
        <div className="orderDelivery-user">
          <div className="receiver">
            <div className="receiverOrder">
              <div className="trackCode brl">
                <p>کد پیگیری مرسوله :</p>
                <p className="pr">CDCP-{order.data.id} </p>
              </div>

              {order.deliveryType.typeCity === 360 &&
                order.deliveryType.orderPeykCode && (
                  <div className="fact-code-marsouleh brl pr">
                    <span className="fact-title">شناسه تحویل مرسوله :</span>
                    <span>
                      {order.deliveryType.orderPeykCode
                        ? order.deliveryType.orderPeykCode
                        : ""}{" "}
                    </span>
                  </div>
                )}

              {order.deliveryType.typeDelivery === 2 &&
                order.deliveryType?.delivery !== "" && (
                  <div className="fact-id-marsouleh brl pr">
                    <a
                      href={
                        "https://tracking.post.ir/?id=" +
                        order.deliveryType.delivery
                      }
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span className="fact-title">کد رهگیری مرسوله :</span>
                      <span className="tracking pl">
                        {order.deliveryType.delivery}
                      </span>
                    </a>
                  </div>
                )}

              <div className="receiverUser">
                <p className="pr"> وضعیت مرسوله :</p>
                <p className="badge-status">{order.data.status}</p>
              </div>
            </div>

            <div className="location">
              <div
                className={
                  order.deliveryType.typeDelivery === 1 &&
                    order.deliveryType.delivery !== null
                    ? "shippingCost brl"
                    : "shippingCost"
                }
              >
                <p>هزینه ارسال :</p>
                <p className="pr">
                  {" "}
                  {Number(order.data.shipping).toLocaleString()} تومان
                </p>
              </div>

              {order.deliveryType.typeDelivery === 1 &&
                order.deliveryType.delivery !== null && (
                  <div className="fact-date-marsouleh pr">
                    <span className="fact-title">زمان تحویل مرسوله :</span>
                    <span>{order.deliveryType.delivery} </span>
                    <span className="pr">
                      ساعت
                      {order.orderPeyk.time_start}-{order.orderPeyk.time_end}
                    </span>
                  </div>
                )}
            </div>

            <div className="orderProductsItem">
              {order.products.map((pv) => (
                <div key={pv.id} className="ordersItemShow">
                  <div className="order-image-box">
                    <img src={pv.image} />
                  </div>
                  <div className="order-factor-info">
                    <p>
                      <strong>
                        {pv.name}
                        {pv.attribute && (
                          <span className="attributeItem">
                            ({pv.attribute})
                          </span>
                        )}
                      </strong>
                    </p>
                    {pv.giftName && (
                      <p className="giftItem">هدیه خرید: {pv.giftName}</p>
                    )}
                    <p>تعداد: {pv.quantity}</p>

                    <p>مبلغ: {Number(pv.priceSale).toLocaleString()} تومان</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
